import { useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export const useAuthenticationCheck = () => {
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  // Excluir rutas donde no debe ejecutarse el check del perfil
  const excludedRoutes = ['/auth', '/intro', '/total-usuarios'];
  const shouldSkipProfileCheck = excludedRoutes.includes(location.pathname);

  return {
    isAuthenticated,
    shouldSkipProfileCheck,
    currentPath: location.pathname
  };
};
